export const LANGUAGE = '[Language]';

export const SET_LOCALE = `${LANGUAGE} SET_LOCALE`;
